<script setup lang="ts">
import type { Schemas } from '#shopware'
import type { PromotionData } from '~/composables/usePromotion'

const props = defineProps<{
    config: Schemas['BrandSlide']
    index: number
}>()

const slideContentBrandEl = ref<HTMLDivElement | null>(null)
const trackingData: { promotion: PromotionData | null } = inject('trackingData', { promotion: null })
const { selectPromotion, computedPromotionData } = usePromotionObserver(
    slideContentBrandEl,
    trackingData?.promotion,
    props.index + 1
)

function onBrandClick(event: MouseEvent) {
    if (computedPromotionData?.value) selectPromotion(computedPromotionData.value, event)
}
</script>

<template>
    <div ref="slideContentBrandEl" class="relative aspect-[3/2] bg-base-200">
        <MiscLink
            :to="config.url?.value ?? ''"
            class="w-full h-full flex justify-center items-center"
            @click="onBrandClick($event)"
        >
            <MiscImage
                v-if="config.logo?.path != null"
                class="w-[75%] h-[45%] flex justify-center items-center object-contain"
                :src="config.logo.path"
                :alt="config.logo.translated?.alt"
                :media-width="config.logo.metaData?.width"
                :media-height="config.logo.metaData?.height"
                lazy-load
            />
        </MiscLink>
    </div>
</template>
